import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Control } from 'shared/components/fields/control';
import { TextInputWrapper } from 'shared/components/fields/text';
import { BoilerControlType, } from 'console/climatic/setting-tabs/type';
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useEditingProps } from 'z3k-settings/components/utils/unpack-props';
import { useCallback, useContext, useMemo } from 'react';
import { removeNulls } from 'utils';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { MaterialDropdown } from 'shared/components/fields';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { HeatingCircuit } from 'z3k-config';
import { boiler_id_2_adapter_slot, boiler_id_2_relay_id, boiler_water_sensor_id, } from 'console/climatic/constants';
import { findBoilerAdapterBySlot } from 'z3k-parser/lib';
export function BoilerCard({ boiler_settings, number }) {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const nameEditingProps = useEditingProps(boiler_settings.id, 'heating_circuits', 'name');
    const boiler_control_type_options = useMemo(() => removeNulls([
        { text: 'Отключен', value: BoilerControlType.OFF },
        { text: 'Реле', value: BoilerControlType.RELAY },
        boiler_settings.has_adapter_on_slot
            ? {
                text: 'Цифровая шина',
                value: BoilerControlType.DIGITAL,
            }
            : null,
        boiler_settings.show_unknown_option
            ? {
                text: 'Неизвестный',
                value: BoilerControlType.UNKNOWN,
            }
            : null,
    ]), [boiler_settings.has_adapter_on_slot, boiler_settings.show_unknown_option]);
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { options: boiler_control_type_options, ...input_props })), [boiler_control_type_options]);
    const onTypeChange = (new_value) => {
        replace_config(HeatingCircuit.get.modifyById(config, boiler_settings.id, (circuit) => {
            switch (new_value) {
                case BoilerControlType.OFF:
                    return {
                        ...HeatingCircuit.setEnabled(circuit, false),
                        name: boiler_settings.name,
                        control_devices: [],
                        water_temp_sensor: null,
                    };
                case BoilerControlType.RELAY:
                    return {
                        ...HeatingCircuit.setEnabled(circuit, true),
                        name: boiler_settings.name,
                        control_devices: [boiler_id_2_relay_id(circuit.id)],
                        water_temp_sensor: boiler_water_sensor_id,
                    };
                case BoilerControlType.DIGITAL: {
                    const adapter = findBoilerAdapterBySlot(config, boiler_id_2_adapter_slot(circuit.id));
                    return {
                        ...HeatingCircuit.setEnabled(circuit, true),
                        name: boiler_settings.name,
                        control_devices: [adapter.id],
                        water_temp_sensor: adapter.id,
                    };
                }
                case BoilerControlType.UNKNOWN:
                    return circuit;
            }
        }));
    };
    return (_jsxs(SettingCard, { title: `Котёл №${number}`, container_props: {
            gridTemplateColumns: 'repeat(auto-fill, minmax(235px, 1fr))',
            alignItems: 'start',
        }, children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", ...nameEditingProps, field: TextInputWrapper, help_id: null }), _jsx(ControlWithoutValidation, { label: "\u0422\u0438\u043F", value: boiler_settings.control_type, onChange: onTypeChange, field: type_field, help_id: null })] }));
}
